
import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { PreOrderListModel } from '../models/models'

export class GetPreOrderApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'MyReports/getPreOrder',
      requesterInfo,
    })
  }

  public async getPreOrder(request: string): Promise<PreOrderListModel[]> {
    return await this.postAsync<PreOrderListModel[]>(JSON.stringify(request))
  }
}
